import React, { useState, useCallback } from 'react';
import { ScrollView, RefreshControl } from 'react-native';
import { styles } from '../Common.style';

/**
 * A generic wrapper component that adds pull-to-refresh functionality.
 *
 * @param {object} props
 * @param {React.ReactNode} props.children - The content to be rendered inside the scrollable view.
 * @param {Function} props.onRefresh - The async function to call when a refresh is triggered.
 * @param {boolean} props.loading - A boolean to indicate if data is currently loading (shows the spinner).
 */
function RefreshableScreen({ children, onRefresh, loading }) {
  const [isRefreshing, setIsRefreshing] = useState(false);

  const handleRefresh = useCallback(async () => {
    setIsRefreshing(true);
    try {
      if (onRefresh) {
        await onRefresh();
      }
    } catch (e) {
      console.error('Error during refresh:', e);
    } finally {
      setIsRefreshing(false);
    }
  }, [onRefresh]);

  return (
    <ScrollView
      style={styles.container}
      contentContainerStyle={{ flexGrow: 1 }}
      refreshControl={<RefreshControl refreshing={isRefreshing || loading} onRefresh={handleRefresh} />}
    >
      {children}
    </ScrollView>
  );
}

export default RefreshableScreen;
